import React, { useEffect, useState } from "react";
import "./TypingLoader.css";
import { FaFeatherAlt} from "react-icons/fa";
const TypingLoader = ({text}) => {
  // const text = "Medhas AI";
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (displayText.length < text.length) {
          setDisplayText(text.slice(0, displayText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 10000);
        }
      } else {
        if (displayText.length > 0) {
          setDisplayText(text.slice(0, displayText.length - 1));
        } else {
          setIsDeleting(false);
        }
      }
    }, isDeleting ? 80 : 150);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting]);

  return (
    <h2>
      {displayText}
      <span className="cursor"><FaFeatherAlt/></span>
    </h2>
  );
};

export default TypingLoader;